// https://research.arizona.edu/faq/what-do-you-mean-when-you-say-use-title-case-proposalproject-titles
const NON_CAPITALIZED_WORDS = [
  'and',
  'as',
  'but',
  'for',
  'if',
  'nor',
  'or',
  'so',
  'yet',
  'a',
  'an',
  'the',
  'as',
  'at',
  'by',
  'for',
  'in',
  'of',
  'off',
  'on',
  'per',
  'to',
  'up',
  'via',
];

/**
 * Converts a string to title case (excludes capitalization of certain words).
 */
export function titleCase(str: string | null | undefined) {
  if (!str) {
    return '';
  }

  const words = str?.split(' ') ?? [];
  const captilizedWords = words.map((word, index) => {
    if (NON_CAPITALIZED_WORDS.includes(word) && index !== 0) {
      return word.toLowerCase();
    }
    return word.charAt(0).toUpperCase() + word.slice(1).toLowerCase();
  });

  return captilizedWords.join(' ');
}
